import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full p-3 overflow-scroll rounded-md gap-3 border border-gray-400 mt-8 flex justify-start items-start flex-col text-left" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"text-sm font-semibold\">Goals History</div><div class=\"grid grid-cols-6 w-full overflow-scroll sx:w-[700px] text-sm\"><div class=\"px-2 py-1 bg-[#cdffee56] rounded-md h-fit w-fit\"> Date started </div><div class=\"px-2 py-1 bg-[#cdffee56] rounded-md h-fit w-fit\"> Year Total Read </div><div class=\"px-2 py-1 bg-[#cdffee56] rounded-md h-fit w-fit\"> Monthly Read </div><div class=\"px-2 py-1 bg-[#cdffee56] rounded-md h-fit w-fit\"> Pages Per Day </div><div class=\"px-2 py-1 bg-[#cdffee56] rounded-md h-fit w-fit\"> Pages Per Week </div><div class=\"px-1 py-1 bg-[#cdffee56] rounded-md h-fit w-fit\">Props</div></div>", 2)
const _hoisted_4 = { class: "w-full overflow-scroll sx:w-[700px]" }
const _hoisted_5 = { class: "px-2" }
const _hoisted_6 = { class: "px-2" }
const _hoisted_7 = { class: "px-2" }
const _hoisted_8 = { class: "px-2" }
const _hoisted_9 = { class: "px-2" }
const _hoisted_10 = { class: "px-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "Update Book Goals", -1)
const _hoisted_14 = { class: "" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-xs"
}, "Select book goal interval", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select goal interval", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1 Month", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "3 Month", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "6" }, "6 Month", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "12" }, "12 Month", -1)
const _hoisted_21 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  class: "rounded-sm px-4 py-2 font-medium bg-boxColor text-white text-sm outline-none hover:shadow-typeBox",
  type: "submit"
}, " Update Goal ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUserGoals.books, (books) => {
        return (_openBlock(), _createElementBlock("div", {
          key: books.id,
          class: "grid grid-cols-6 mt-3 w-full text-sm"
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString($data.moment(books.createdAt).format("DD-MM-YYYY")) + " + " + _toDisplayString(books.timeInterval), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(books.totalRead), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(books.monthlyRead), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(books.pagesPerDay), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(books.pagesPerWeek), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = $event => ($data.modal1 = true))
            }, [
              _createElementVNode("button", {
                onClick: $event => ($options.editGoal(books._id))
              }, "Edit", 8, _hoisted_11)
            ]),
            _createTextVNode(" / "),
            _createElementVNode("span", {
              class: "cursor-pointer",
              onClick: $event => ($options.removeCurrentGoal(books._id))
            }, "Delete", 8, _hoisted_12)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_Card, {
      "modal-1": $data.modal1,
      "onUpdate:modal1": _cache[7] || (_cache[7] = $event => ($data.modal1 = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.updateGoal && $options.updateGoal(...args)), ["prevent"])),
          class: "flex flex-col w-auto gap-y-3 bg-white shadow-typeBox px-4 py-6 rounded-md"
        }, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm",
            type: "text",
            placeholder: "Total Year Read",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.totalRead) = $event))
          }, null, 512), [
            [_vModelText, $options.totalRead]
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm",
            type: "text",
            placeholder: "No of Monthly Read",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($options.monthlyRead) = $event))
          }, null, 512), [
            [_vModelText, $options.monthlyRead]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Pages to read per day",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($options.pagesPerDay) = $event)),
            class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm"
          }, null, 512), [
            [_vModelText, $options.pagesPerDay]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($options.pagesPerWeek) = $event)),
            placeholder: "Pages to read per week",
            class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm"
          }, null, 512), [
            [_vModelText, $options.pagesPerWeek]
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($options.timeInterval) = $event)),
              placeholder: "Enter working Days",
              class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm"
            }, _hoisted_21, 512), [
              [_vModelSelect, $options.timeInterval]
            ])
          ]),
          _hoisted_22
        ], 32)
      ]),
      _: 1
    }, 8, ["modal-1"])
  ]))
}